import React, { useContext, useEffect, useState } from 'react';
import '../assets/styles/nav.css';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useModal } from "../context/ModalContext";
import { UserContext } from "../context/UserContext.jsx";
import useIsMobile from '../hooks/useIsMobile';
import Button from '../components/Button.jsx'


const Nav = ({ onLinkClick }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const { userName, logout, reloadAddresses, reloadPaymentMethods } = useContext(UserContext);
    const { openModal } = useModal();

    // Verifica se está em uma rota filha de /minha-conta
    const isMinhaConta = location.pathname.startsWith('/minha-conta');
    const isMobile = useIsMobile();

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    const siteLinks = [
        { label: "Sua suplementação completa", to: "#sua-suplementacao-completa" },
        { label: "Na Mídia", to: "#na-midia" },
        { label: "Eu sou meu primeiro cliente", to: "#fundador" },
        { label: "A nova geração da suplementação", to: "#how-works" },
        { label: "Como funciona", to: "#passo-a-passo" },
        { label: "A Puríssima cuida de você por inteiro", to: "#whole" },
        { label: "Seu Ritual", to: "#ritual" },
        { label: "Sabores Encantadores", to: "#flavors" },
        { label: "Kids", to: "#my-kids" },
        { label: "O Unicórnio", to: "#unicorn" },
        { label: "Perguntas Frequentes", to: "#faq" },
    ];

    const accountLinks = [
        { 
            to: "/minha-conta/dashboard", 
            label: (
            <>
                <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clipPath="url(#clip0_12258_117018)">
                <path
                  d="M12.4698 11.0391C11.7674 11.5273 10.9103 11.8131 9.99958 11.8131C9.08887 11.8131 8.23172 11.5273 7.52934 11.045C6.38053 11.5452 5.46387 12.4919 5.02934 13.7125C4.90434 14.0638 4.7972 14.4151 4.71387 14.7783C6.02339 16.2192 7.9103 17.1302 9.99958 17.1302C12.0889 17.1302 13.9817 16.2192 15.2912 14.7783C15.2079 14.421 15.1008 14.0697 14.9758 13.7125C14.5412 12.4859 13.6127 11.5452 12.4758 11.0391H12.4698Z"
                  fill="#A7A39A"
                />
                <path
                  d="M9.99977 10.3527C11.6069 10.3527 12.9224 9.04878 12.9224 7.42925C12.9224 5.80972 11.6069 4.51172 9.99977 4.51172C8.39262 4.51172 7.07715 5.81568 7.07715 7.42925C7.07715 9.04283 8.39262 10.3527 9.99977 10.3527Z"
                  fill="#A7A39A"
                />
                <path
                  d="M10 0C4.4881 0 0 4.48348 0 9.99702C0 15.5106 4.4881 20 10 20C15.5119 20 20 15.5106 20 9.99702C20 4.48348 15.5119 0 10 0ZM10 18.5591C5.27976 18.5591 1.43452 14.7187 1.43452 9.99107C1.43452 5.26347 5.27976 1.43495 10 1.43495C14.7202 1.43495 18.5655 5.27538 18.5655 9.99702C18.5655 14.7187 14.7262 18.565 10 18.565V18.5591Z"
                  fill="#A7A39A"
                />
              </g>
              <defs>
                <clipPath id="clip0_12258_117018">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
             Minha conta
            </>
            ),
            onClick: onLinkClick
        },
        { 
            to: "/minha-conta/meus-pedidos", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                <path d="M17 5.5L9 1L1 5.5M17 5.5V14.5L9 19M17 5.5L9 10M9 19L1 14.5V5.5M9 19V10M1 5.5L9 10" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> Meus Pedidos
            </>
            ),
            onClick: onLinkClick
        },
        { 
            to: "/minha-conta/minha-familia", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none" stroke="#fff">
                <path d="M7 8C8.65685 8 10 6.65685 10 5C10 3.34315 8.65685 2 7 2C5.34315 2 4 3.34315 4 5C4 6.65685 5.34315 8 7 8Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 7C16.6569 7 18 5.65685 18 4C18 2.34315 16.6569 1 15 1C13.3431 1 12 2.34315 12 4C12 5.65685 13.3431 7 15 7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1 17C1 13.6863 3.68629 11 7 11C10.3137 11 13 13.6863 13 17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 17C10 14.7909 11.7909 13 14 13C16.2091 13 18 14.7909 18 17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>{" "} Minha família
            </>
            ),
            onClick: onLinkClick
        },
        { 
            to: "/minha-conta/endereco-de-entrega", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                <path d="M4 13C4 13.5304 4.21071 14.0391 4.58579 14.4142C4.96086 14.7893 5.46957 15 6 15C6.53043 15 7.03914 14.7893 7.41421 14.4142C7.78929 14.0391 8 13.5304 8 13M4 13C4 12.4696 4.21071 11.9609 4.58579 11.5858C4.96086 11.2107 5.46957 11 6 11C6.53043 11 7.03914 11.2107 7.41421 11.5858C7.78929 11.9609 8 12.4696 8 13M4 13H2V9M8 13H14M14 13C14 13.5304 14.2107 14.0391 14.5858 14.4142C14.9609 14.7893 15.4696 15 16 15C16.5304 15 17.0391 14.7893 17.4142 14.4142C17.7893 14.0391 18 13.5304 18 13M14 13C14 12.4696 14.2107 11.9609 14.5858 11.5858C14.9609 11.2107 15.4696 11 16 11C16.5304 11 17.0391 11.2107 17.4142 11.5858C17.7893 11.9609 18 12.4696 18 13M18 13H20V7M1 1H12V13M20 7H12M20 7L17 2H12M2 5H6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> Endereço de Entrega
            </>
            ),
            onClick: (e) => {
                reloadAddresses?.();
                onLinkClick?.(e);
            }
        },
        { 
            to: "/minha-conta/dados-pessoais", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M13 5H15M13 9H15M5 13H15M1 4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H16C16.7956 1 17.5587 1.31607 18.1213 1.87868C18.6839 2.44129 19 3.20435 19 4V14C19 14.7956 18.6839 15.5587 18.1213 16.1213C17.5587 16.6839 16.7956 17 16 17H4C3.20435 17 2.44129 16.6839 1.87868 16.1213C1.31607 15.5587 1 14.7956 1 14V4ZM5 7C5 7.53043 5.21071 8.03914 5.58579 8.41421C5.96086 8.78929 6.46957 9 7 9C7.53043 9 8.03914 8.78929 8.41421 8.41421C8.78929 8.03914 9 7.53043 9 7C9 6.46957 8.78929 5.96086 8.41421 5.58579C8.03914 5.21071 7.53043 5 7 5C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> Dados Pessoais
            </>
            ),
            onClick: onLinkClick
        },
        { 
            to: "/minha-conta/dados-pagamento", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M13 5H15M13 9H15M5 13H15M1 4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H16C16.7956 1 17.5587 1.31607 18.1213 1.87868C18.6839 2.44129 19 3.20435 19 4V14C19 14.7956 18.6839 15.5587 18.1213 16.1213C17.5587 16.6839 16.7956 17 16 17H4C3.20435 17 2.44129 16.6839 1.87868 16.1213C1.31607 15.5587 1 14.7956 1 14V4ZM5 7C5 7.53043 5.21071 8.03914 5.58579 8.41421C5.96086 8.78929 6.46957 9 7 9C7.53043 9 8.03914 8.78929 8.41421 8.41421C8.78929 8.03914 9 7.53043 9 7C9 6.46957 8.78929 5.96086 8.41421 5.58579C8.03914 5.21071 7.53043 5 7 5C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> Meios de Pagamento
            </>
            ),
            onClick: (e) => {
                reloadPaymentMethods?.();
                onLinkClick?.(e);
            }
        },
        { 
            to: "/minha-conta/alterar-senha", 
            label: (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 15V19M8 18L12 16M8 16L12 18M3 15V19M1 18L5 16M1 16L5 18M17 15V19M15 18L19 16M15 16L19 18M5 12C5 11.4696 5.21071 10.9609 5.58579 10.5858C5.96086 10.2107 6.46957 10 7 10H13C13.5304 10 14.0391 10.2107 14.4142 10.5858C14.7893 10.9609 15 11.4696 15 12M7 4C7 4.79565 7.31607 5.55871 7.87868 6.12132C8.44129 6.68393 9.20435 7 10 7C10.7956 7 11.5587 6.68393 12.1213 6.12132C12.6839 5.55871 13 4.79565 13 4C13 3.20435 12.6839 2.44129 12.1213 1.87868C11.5587 1.31607 10.7956 1 10 1C9.20435 1 8.44129 1.31607 7.87868 1.87868C7.31607 2.44129 7 3.20435 7 4Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> Alterar Senha
            </>
            ),
            onClick: onLinkClick
        },
        { to: "/", label: "Voltar para loja", onClick: onLinkClick },
        { to: "/", label: "Sair", onClick: handleLogout },
    ];

    const handleAnchorClick = (e, hash) => {
        e.preventDefault();
        if (!hash?.startsWith('#')) return;

        // Fecha menu (se mobile/offcanvas)
        if (onLinkClick) onLinkClick();

        const isHomePath = location.pathname === '/' || location.pathname === '/wa/comercial';
        if (!isHomePath) {
            // Navega para Home levando o hash
            navigate({ pathname: '/', hash });
        } else {
            // Já está na Home: scroll imediato
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className="Nav">
            <ul className={isMobile && isMinhaConta ? "" : "overflow-menu"}>
                {(isMobile && isMinhaConta
                    ? accountLinks.map((link, index) => (
                        <li key={index}>
                        {link.isText ? (
                            <span>{link.label}</span>
                        ) : (
                            <NavLink to={link.to} onClick={link.onClick || onLinkClick}>
                                {link.label}
                            </NavLink>
                        )}
                        </li>
                    ))
                    : siteLinks.map((link, index) => (
                        <li key={index}>
                            <a
                              href={link.to}
                              onClick={(e) => handleAnchorClick(e, link.to)}
                            >
                                {link.label}
                            </a>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
};

export default Nav;